// Вердикт: полоса результата и разбор под ней.
//
// Это был отдельный экран — «Проверка», третий из четырёх. С 11 сентября 2026
// он показывается НА экране задачи, под её условием, и отдельного экрана
// больше нет. Причина: между отправкой и вердиктом менялась вся страница, и
// условие, по которому ученик только что считал, исчезало в ту же секунду.
// Теперь оно стоит выше вердикта и никуда не девается — поэтому здесь нет
// повтора условия (`.recap`), который был нужен старому экрану.
//
// Чего здесь нет и не будет: `result.errorCode`. Ярлык заблуждения и досье
// прошлых ошибок ученику не показываются — точность классификации типа ошибки
// у лучшей модели 40–47%, и два больших RCT показали, что даже верно названная
// ошибка не улучшает обучение. Код нужен серверу для выбора следующей задачи.

import { Formula } from "../lib/Formula";
import { IconCheck, IconCross } from "./Icons";
import { Solution, type SolutionUnclear } from "./Solution";

export function Verdict({
  correct,
  line,
  raw,
  answerDisp,
  solution,
  unclear,
}: {
  correct: boolean;
  /** Заголовок из `src/lib/verdict-lines.ts`. Выбирает вызывающий: зерно
      берётся один раз на проверку, иначе строка меняется на перерисовках. */
  line: string;
  raw: string;
  answerDisp: string | null;
  solution: string[];
  /** Отметки «неясно» на шагах — там, где разбор читает ученик. */
  unclear?: SolutionUnclear;
}) {
  return (
    <>
      <div className={`banner ${correct ? "banner--grow" : "banner--miss"}`}>
        <div className="banner__mark">
          {correct ? <IconCheck size={22} color="#fff" /> : <IconCross size={22} color="#fff" />}
        </div>
        <div style={{ minWidth: 0 }}>
          <div className="banner__title">{line}</div>
          <div className="banner__line">
            {correct ? (
              <>
                Ответ{" "}
                <span className="underline--grow">
                  <Formula source={answerDisp ?? ""} />
                </span>
              </>
            ) : (
              <>
                Ты ответил <span className="underline--miss">{raw}</span> · верно{" "}
                <span className="underline--grow">
                  <Formula source={answerDisp ?? ""} />
                </span>
              </>
            )}
          </div>
        </div>
      </div>

      {/* Разбор приходит при любом вердикте, кроме опечатки: она эталона не
          открывает вовсе, и `solution` там пуст. Открыт сразу и на верном
          ответе — нажатия между ответом и объяснением нет. */}
      {solution.length > 0 ? (
        <div className="card">
          <div className="card__label">Разбор</div>
          <Solution steps={solution} unclear={unclear} />
        </div>
      ) : null}
    </>
  );
}
